import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';

class TableView extends Component {
    // START private methods
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        Service.fetchDashboardMetrics().finally(() => {
            this.setState({ showMask: false });
        });
    }

    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Dashboard Metrics",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;

        this.tableHeaderColumnList = [
            { columnName: "Metric", key: "metricName"},
            { columnName: "Last 7 days", key: "totalLastWeek"},
            { columnName: "Last 30 days", key: "totalLastMonth"},
            { columnName: "MoM", key: "mom"},
            { columnName: "MoMLY", key: "moMLY"},
            { columnName: "Current Month", key: "currentMonthTotal"},
        ]
    }

    componentDidMount () {
        var fetchEventForResultData = Service.event.onDashboardMetrics;
        fetchEventForResultData.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                    >

                    </TableSearchHeader>
                   <TableHead
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                   />
                   <TableBody
                       tableDataResults = {this.state.responseTableData.results}
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                       showMask = {this.state.showMask}
                   >
                   </TableBody>
                </Table>
            </div>
        );
    }
}

export default TableView;